import type { ButtonProps } from "@ecco/ui/button";
import { focusOutline } from "@ecco/ui/css/focus";

export const styles = {
    reviewsTriggerButton: {
        type: "button",
        variant: "unstyled",
        px: 0,
        py: 0,
        display: "flex",
        alignItems: "baseline",
        flexDir: "column",
        cursor: "pointer",
        textAlign: "left",
        h: "auto",
        minH: "unset",
        _focus: { outline: "none", boxShadow: "none" },
        _focusVisible: { ...focusOutline, boxShadow: "none" },
    } satisfies Partial<ButtonProps>,
};
